module.exports = __webpack_public_path__ + "3516032546c9fb7e6434014fbae861ec.png";